<template>
	<v-snackbar
		:color="color"
		:app="app"
		:left="left"
		:right="right"
		:top="top"
		:bottom="bottom"
		:timeout="timeout"
		:value="value"
		@input="onInput"
	>
		{{ message }}
		<template v-slot:action="{ attrs }">
			<v-btn
				color="red"
				text
				v-bind="attrs"
				@click="onClose"
			>
				Close
			</v-btn>
		</template>
	</v-snackbar>
</template>

<script>
export default {
	props: {
		app: Boolean,
		color: String,
		message: String,
		left: Boolean,
		right: Boolean,
		top: Boolean,
		bottom: Boolean,
		timeout: [String, Number],
	},
	data() {
		return {
			value: true,
		}
	},
	methods: {
		onInput(event) {
			if (!event) {
				this.$emit('close')
			}
		},
		onClose() {
			this.$emit('close')
		},
	},
}
</script>
